import React, { useState, useEffect } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

const PdfViewer = ({ fileContent }) => {
  const [error, setError] = useState(null);
  const [pdfBlob, setPdfBlob] = useState(null);

  useEffect(() => {
    const convertBase64ToBlob = () => {
        const byteCharacters = atob(fileContent.split(',')[1]);
        const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        setPdfBlob(blobUrl);
    };

    convertBase64ToBlob();
    return () => {
        // Cleanup URL object
        if (pdfBlob) URL.revokeObjectURL(pdfBlob);
    };
}, []);

  return (
    <div style={{ height: '100%', width: '100%' }}>
            {pdfBlob ? (
                <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
                <Viewer fileUrl={pdfBlob} />
                </Worker>
            ) : (
                <p>Loading PDF...</p>
            )}
        </div>
  );
};

export default PdfViewer;
